


import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { login as reduxLogin } from "../redux/actions/authActions";
import { useAuth } from "../context/AuthContext";
// import LogoImg from "../images/logo.png";
import LogoImg from "../images/loginLogo.png";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevents form submission if already loading

    setLoading(true);

    try {
      const response = await dispatch(reduxLogin(email, password));

      if (response?.meta?.status) {
        const { token, admin } = response.data;

        // Store token and user info in localStorage
        localStorage.setItem("token", token);
        localStorage.setItem("email", admin.email);
        localStorage.setItem("userId", admin.id);

        login(); // Update auth context

        toast.success(response.meta.message || "Login successful");
        navigate("/dashboard");
      } else {
        toast.error(response?.meta?.message || "Invalid email or password.");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <div className="w-1/2 h-screen flex justify-center items-center bg-black">
        <img className="w-[60%]" src={LogoImg} alt="Logo" />
      </div>
      <div className="w-1/2 flex flex-col gap-4 justify-center items-center bg-gray-200">
        <div className="w-[80%]">
          <h1 className="text-2xl font-bold">Sign in</h1>
          <p>Sign in to your account</p>
        </div>
        <form
          className="bg-white w-[80%] h-[50%] flex flex-col justify-center items-center gap-4 rounded-2xl"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col justify-center w-[80%]">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              className="py-2 px-2 bg-gray-200 rounded-lg"
              placeholder="abc123@gmail.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col justify-center w-[80%]">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="py-2 px-2 bg-gray-200 rounded-lg"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="bg-black text-white p-2 w-[80%] rounded-md"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
